import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/channels/internal/$channelId/thread/$threadId` activates
// the reply-thread column (col 3). The Channels LAYOUT route (channels.tsx) reads
// `$threadId` off the leaf match and renders the ThreadPanel via ColumnLayout.
// Mirrors forms/$formId/$responseId.
export const Route = createFileRoute(
  "/$orgSlug/$eventSlug/channels/internal/$channelId/thread/$threadId",
)({
  component: () => null,
})
